export const FORM_SECTION_TITLE_CLASS = "app-section-title";

export const FORM_LABEL_WITH_SPACING_CLASS = "app-label app-label-spaced";

export const FORM_CONTROL_CLASS = "app-input w-full";

export const FORM_COMPACT_CONTROL_CLASS = "app-input app-input-compact w-full";

export const FORM_SELECT_CLASS = "app-input app-select w-full";

export const FORM_HELP_TEXT_CLASS = "app-help-text";

export const FORM_ERROR_TEXT_CLASS = "app-error-text";

export const FORM_CARD_TIGHT_CLASS = "app-card space-y-3 p-4";

export const FORM_CARD_SECTION_CLASS = "app-card mt-6 space-y-4 p-4";

export const FORM_CONTENT_HEADER_CLASS = "px-4 sm:px-0";

export const FORM_CONTENT_BODY_CLASS = "px-4 py-6 sm:px-0";

export const FORM_SECTION_HEADING_CLASS = "app-title text-base font-semibold";

export const FORM_MUTED_TEXT_CLASS = "app-text-muted text-sm";

export const FORM_DIVIDER_TOP_CLASS = "app-divider-top mt-6";

export const FORM_DIVIDED_LIST_CLASS = "app-divide-y";

export const FORM_INLINE_ACTION_ROW_CLASS = "mt-6 flex gap-3";

export const FORM_LIST_ITEM_ROW_CLASS = "flex items-start justify-between gap-3 py-4";

